document.addEventListener('DOMContentLoaded', () => {
  const HOST_SELECTOR_ALL = 'shopify-forms-embed';
  const STYLE_ID_PREFIX = 'gk-forms-shadow-style';
  const REQUIRED_CONSENT_NAMES = ['emailConsent', 'phoneConsent'];
  const DISABLED_BUTTON_MESSAGE = 'Zaznacz obie wymagane zgody, aby aktywować przycisk.';

  const VALIDATION_CSS = `
    form[data-testid="form"] button[data-testid="btn-form-submit"][disabled]{
      cursor: not-allowed !important;
      opacity: 0.5 !important;
    }
  `;


  // [Forms] script loaded, waiting for hosts...

  // STYLES IN FOOTER
  const TEST_CSS_DEFAULT = `
    form[data-testid="form"] > output[role="alert"]{
      grid-column: 1 / -1 !important;
      margin-top: -8px !important;
      font-size: 12px !important;
      line-height: 16px !important;
    }

    [data-sizing="form-wrapper"] {
      max-width: none !important;
      width: 100% !important;
      padding-top: 2px !important;
    }

    form[data-testid="form"]{
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 16px !important;
      align-items: start !important;
    }

    form[data-testid="form"] > div[class*="_formFieldContainer_"]{
      width: 100% !important;
      min-width: 0 !important;
    } 

    form[data-testid="form"] > div[class*="_consentCheckboxContainer_"],
    form[data-testid="form"] > div[class*="_formPhoneInputContainer_"],
    form[data-testid="form"] > button[data-testid="btn-form-submit"]{
      grid-column: 1 / -1 !important;
      width: 100% !important;
      max-width: none !important;
      justify-self: stretch !important;
    }

    form[data-testid="form"] > div[class*="__consentCheckboxContainer_"]{
      display: flex !important;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      gap: 12px !important;
      text-align: left !important;
    }

    form[data-testid="form"] > div[class*="__consentCheckboxContainer_"] label,
    form[data-testid="form"] > div[class*="__consentCheckboxContainer_"] p,
    form[data-testid="form"] > div[class*="__consentCheckboxContainer_"] span{
      flex: 1 1 auto !important;
      max-width: none !important;
      text-align: left !important;
      white-space: normal !important;
    }

    form[data-testid="form"] > div[class*="__formPhoneInputContainer_"]{
      max-width: none !important;
    }

    form[data-testid="form"] div[class*="_consentCheckboxContainer_"]:has(fieldset[name="emailConsent"]) { order: 1 }
    form[data-testid="form"] div[class*="_consentCheckboxContainer_"]:has(fieldset[name="phoneConsent"]) { order: 2 }
    form[data-testid="form"] button[class*="_formSubmitButton_"] { order: 3 }

    form[data-testid="form"] span[class*="_textBody_"] { font-size: 11px !important; }

    @media (max-width: 768px){
      form[data-testid="form"]{ grid-template-columns: 1fr !important; }
    }
    @media (min-width: 769px){
      form[data-testid="form"] div[class*="_formFieldContainer_"]:has(input[id="first_name"]) { order: -3; }
      form[data-testid="form"] div[class*="_formFieldContainer_"]:has(input[id="last_name"]) { order: -2; }
      form[data-testid="form"] div[class*="_formFieldContainer_"]:has(input[id="email"]) { order: -1; }
    }
  `;

  // STYLES FOR FORM IN MODAL
  const TEST_CSS_MODAL = `
    form[data-testid="form"] > output[role="alert"]{
      grid-column: 1 / -1 !important;
      margin-top: -8px !important;
      font-size: 12px !important;
      line-height: 16px !important;
    }

    [data-sizing="form-wrapper"] {
      max-width: none !important;
      width: 100% !important;
      padding-top: 2px !important;
    }

    [data-sizing="form-wrapper"] label {
      top: var(--input-label-top) !important;
    }

    form[data-testid="form"]{
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 16px !important;
      align-items: start !important;
    }

    form[data-testid="form"] > div[class*="_formFieldContainer_"]{
      width: 100% !important;
      min-width: 0 !important;
    } 

    form[data-testid="form"] > div[class*="_consentCheckboxContainer_"],
    form[data-testid="form"] > div[class*="_formPhoneInputContainer_"],
    form[data-testid="form"] > button[data-testid="btn-form-submit"]{
      grid-column: 1 / -1 !important;
      width: 100% !important;
      max-width: none !important;
      justify-self: stretch !important;
    }

    form[data-testid="form"] > div[class*="__consentCheckboxContainer_"]{
      display: flex !important;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      gap: 12px !important;
      text-align: left !important;
    }

    form[data-testid="form"] > div[class*="__consentCheckboxContainer_"] label,
    form[data-testid="form"] > div[class*="__consentCheckboxContainer_"] p,
    form[data-testid="form"] > div[class*="__consentCheckboxContainer_"] span{
      flex: 1 1 auto !important;
      max-width: none !important;
      text-align: left !important;
      white-space: normal !important;
    }

    form[data-testid="form"] > div[class*="__formPhoneInputContainer_"]{
      max-width: none !important;
    }

    form[data-testid="form"] div[class*="_consentCheckboxContainer_"]:has(fieldset[name="emailConsent"]) { order: 1 }
    form[data-testid="form"] div[class*="_consentCheckboxContainer_"]:has(fieldset[name="phoneConsent"]) { order: 2 }
    form[data-testid="form"] button[class*="_formSubmitButton_"] { order: 3 }

    form[data-testid="form"] span[class*="_textBody_"] { font-size: 11px !important; }

    @media (max-width: 768px){
      form[data-testid="form"]{ grid-template-columns: 1fr !important; }
    }
    @media (min-width: 769px){
      form[data-testid="form"] div[class*="_formFieldContainer_"]:has(input[id="first_name"]) { order: -3; }
      form[data-testid="form"] div[class*="_formFieldContainer_"]:has(input[id="last_name"]) { order: -2; }
      form[data-testid="form"] div[class*="_formFieldContainer_"]:has(input[id="email"]) { 
        grid-column: 1 / -1 !important;
        order: -1; 
      }
    }
  `

  const shadowObservers = new WeakMap();

  function isInFooter(host) {
    return !!host.closest('footer');
  }

  function isInModal(host) {
    return !!host.closest('#NewsletterModal');
  }

  function pickCssForHost(host) {
    if (isInModal(host)) return TEST_CSS_MODAL;
    if (isInFooter(host)) return TEST_CSS_DEFAULT;
    return null;
  }

  function styleIdForHost(host) {
    if (isInModal(host)) return `${STYLE_ID_PREFIX}-modal`;
    if (isInFooter(host)) return `${STYLE_ID_PREFIX}-default`;
    return null;
  }

  function inject(host) {
    if (!host || !host.shadowRoot) return false;

    const css = pickCssForHost(host);
    const styleId = styleIdForHost(host);

    // Skip injection if the host is not in a recognized context (footer or modal)
    if (!css || !styleId) return false;

    const scopedCss = `${css}\n${VALIDATION_CSS}`;
    const existing = host.shadowRoot.getElementById(styleId);
    if (existing) {
      if (existing.textContent !== scopedCss) existing.textContent = scopedCss;
      return true;
    }

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = scopedCss;
    host.shadowRoot.appendChild(style);

    // styles injected
    return true;
  }

  function prepareNativeValidation(host) {
    const form = host.shadowRoot?.querySelector('form[data-testid="form"]');
    if (!form) return;

    form.noValidate = false;
    form.removeAttribute('novalidate');

    const checkboxes = REQUIRED_CONSENT_NAMES.map((name) => {
      const checkbox = form.querySelector(`input[type="checkbox"][name="${name}"]`);
      if (!checkbox) return null;

      checkbox.required = true;
      checkbox.setAttribute('required', '');
      checkbox.setAttribute('aria-required', 'true');
      return checkbox;
    });

    const submitButton = form.querySelector('button[data-testid="btn-form-submit"]');
    if (!submitButton) return;

    const syncSubmitButton = () => {
      const hasAllConsents = checkboxes.length === REQUIRED_CONSENT_NAMES.length
        && checkboxes.every((checkbox) => checkbox?.checked);

      submitButton.disabled = !hasAllConsents;
      submitButton.setAttribute('aria-disabled', String(!hasAllConsents));
      submitButton.title = hasAllConsents ? '' : DISABLED_BUTTON_MESSAGE;
    };

    checkboxes.filter(Boolean).forEach((checkbox) => {
      if (checkbox.dataset.gkConsentListener) return;

      checkbox.dataset.gkConsentListener = 'true';
      checkbox.addEventListener('change', syncSubmitButton);
    });

    syncSubmitButton();
  }

  function watchHost(host) {
    if (!host || !host.shadowRoot) return false;

    inject(host);

    if (shadowObservers.has(host)) return true;

    prepareNativeValidation(host);

    const mo = new MutationObserver(() => {
      inject(host);
      prepareNativeValidation(host);
    });
    mo.observe(host.shadowRoot, { childList: true, subtree: true });

    shadowObservers.set(host, mo);
    return true;
  }

  function init() {
    const hosts = Array.from(document.querySelectorAll(HOST_SELECTOR_ALL));
    if (!hosts.length) return null;

    hosts.forEach((host) => {
      if (host.shadowRoot) watchHost(host);
    });

    return { hosts };
  }

  init();

  const moDoc = new MutationObserver(() => init());
  moDoc.observe(document.documentElement, { childList: true, subtree: true });
});
